import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 11/14;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 14 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.606 9.4L.272 5.974c-.363-.509-.363-1.272 0-1.78L2.606.787C2.93.333 3.574 0 4.129 0h8.6C13.431 0 14 .571 14 1.27v7.646c0 .701-.57 1.27-1.27 1.27h-8.6c-.557 0-1.2-.332-1.524-.786zM1.3 4.957c-.047.065-.047.234 0 .3L3.642 8.66c.086.12.343.253.487.253h8.598v-7.64H4.129c-.143 0-.402.134-.487.254L1.3 4.957zm1.877.136a1.91 1.91 0 1 1 3.82 0 1.91 1.91 0 0 1-3.82 0zm2.547 0a.637.637 0 1 0-1.274 0 .637.637 0 0 0 1.274 0z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconLabel extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
